import React from "react"
import FieldToggle_ComponentStatefull, {ToggleSize} from "../components/toggle-statefull"
import {FieldFormElementViewProps} from "../../../../render/form-elemnent-view"

export default function FieldToggle_FormElementView(props: FieldFormElementViewProps) {

    const value = props.field.getViewValue(props.model)

    const size : ToggleSize = _.get(props.options, 'size', ToggleSize.SIZE_20) as ToggleSize

    return <FieldToggle_ComponentStatefull className    = {Classes("no-margin", props.className)}
                                           size         = {size}
                                           field        = {props.field}
                                           value        = {value}
                                           isDisabled   = {props.disabled}
                                           onChange     = {props.onChange}/>
}
